module.exports = __webpack_public_path__ + "static/img/icon-confirmations-type1.e8eb9273.svg";